import { selectEnableDataLayerEvents } from 'flux/selectors/application.selectors'
import { selectDataLayerIsActive } from 'flux/selectors/property.selectors'


export function selectShouldTrackRetailerDataLayer(state) {
  const enableDataLayerEvents = selectEnableDataLayerEvents(state)
  if (!enableDataLayerEvents) return false

  const dataLayerIsActive = selectDataLayerIsActive(state)
  if (!dataLayerIsActive) return false

  return true
}
